import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { getMe, logout, startDocumentGeneration, } from "./api";
import Login from "./components/Login";
import Stepper from "./components/Stepper";
import MatterStep from "./components/MatterStep";
import CaseTheoryStep from "./components/CaseTheoryStep";
import DraftStep from "./components/DraftStep";
import GenerationView from "./components/GenerationView";
import { BriefcaseIcon, SpinnerIcon } from "./components/Icons";
function initials(user) {
    var _a, _b;
    const src = (user === null || user === void 0 ? void 0 : user.name) || (user === null || user === void 0 ? void 0 : user.email) || "";
    const parts = src.replace(/@.*/, "").split(/[.\s_-]+/).filter(Boolean);
    return ((((_a = parts[0]) === null || _a === void 0 ? void 0 : _a[0]) || "") + (((_b = parts[1]) === null || _b === void 0 ? void 0 : _b[0]) || "")).toUpperCase() || "U";
}
export default function App() {
    const [auth, setAuth] = useState("loading");
    const [user, setUser] = useState(null);
    const [step, setStep] = useState(1);
    const [matterSource, setMatterSource] = useState("id");
    const [matter, setMatter] = useState(null);
    const [uploadedDocuments, setUploadedDocuments] = useState([]);
    const [classification, setClassification] = useState(null);
    const [caseTheory, setCaseTheory] = useState({ facts: "", law: "", clientGoals: "" });
    const [documentType, setDocumentType] = useState("");
    const [instructions, setInstructions] = useState("");
    const [generation, setGeneration] = useState(null);
    const [genError, setGenError] = useState(null);
    useEffect(() => {
        getMe()
            .then(({ user }) => {
            setUser(user);
            setAuth("in");
        })
            .catch(() => setAuth("out"));
    }, []);
    function onSignedIn(u) {
        setUser(u);
        setAuth("in");
        if (window.location.pathname !== "/app") {
            window.history.replaceState({}, "", "/app");
        }
    }
    async function onLogout() {
        await logout().catch(() => undefined);
        setUser(null);
        setAuth("out");
        window.history.replaceState({}, "", "/login");
    }
    async function onGenerate() {
        setGenError(null);
        try {
            const docsWithRoles = uploadedDocuments.map((d) => ({
                ...d,
                documentRole: d.category ? d.category.replace(/-/g, " ") : "case document",
            }));
            const res = await startDocumentGeneration({
                documentType,
                matter,
                caseTheory,
                uploadedDocuments: docsWithRoles,
                instructions,
            });
            setGeneration({ runId: res.runId, docTypeLabel: res.docType.label });
        }
        catch (e) {
            setGenError(e.message);
        }
    }
    function startOver() {
        setGeneration(null);
        setStep(3);
    }
    if (auth === "loading") {
        return (_jsx("div", { className: "center-spinner", children: _jsx(SpinnerIcon, { size: 32 }) }));
    }
    if (auth === "out") {
        return _jsx(Login, { onSignedIn: onSignedIn });
    }
    const matterLabel = matter ? `${matter.client} v. ${matter.counterparty.replace(/\s*\(.*\)\s*$/, "")}` : null;
    return (_jsxs(_Fragment, { children: [_jsxs("header", { className: "appbar", children: [_jsxs("div", { className: "appbar-l", children: [_jsxs("span", { className: "brand", children: ["Suade", _jsx("span", { className: "dot", children: "." })] }), matterLabel && (_jsxs("span", { className: "matter-chip", title: `${matterLabel} · ${matter.matterId}`, children: [_jsx(BriefcaseIcon, { size: 14 }), _jsxs("span", { className: "txt", children: [matterLabel, " \u00B7 ", matter.matterId] })] }))] }), _jsxs("div", { className: "appbar-r", children: [_jsx("span", { className: "who", children: (user === null || user === void 0 ? void 0 : user.name) || (user === null || user === void 0 ? void 0 : user.email) }), _jsx("span", { className: "avatar", "aria-hidden": "true", children: (user === null || user === void 0 ? void 0 : user.picture) ? _jsx("img", { src: user.picture, alt: "", referrerPolicy: "no-referrer" }) : initials(user) }), _jsx("button", { className: "link-btn", onClick: onLogout, children: "Sign out" })] })] }), _jsx("main", { className: "workspace", children: generation ? (_jsx(GenerationView, { runId: generation.runId, docTypeLabel: generation.docTypeLabel, documentCount: classification === null || classification === void 0 ? void 0 : classification.total, onStartOver: startOver })) : (_jsxs(_Fragment, { children: [_jsx(Stepper, { current: step }), step === 1 && (_jsx(MatterStep, { matterSource: matterSource, setMatterSource: setMatterSource, matter: matter, setMatter: setMatter, uploadedDocuments: uploadedDocuments, setUploadedDocuments: setUploadedDocuments, classification: classification, setClassification: setClassification, onNext: () => setStep(2) })), step === 2 && (_jsx(CaseTheoryStep, { caseTheory: caseTheory, setCaseTheory: setCaseTheory, matter: matter, onBack: () => setStep(1), onNext: () => setStep(3) })), step === 3 && (_jsxs(_Fragment, { children: [_jsx(DraftStep, { documentType: documentType, setDocumentType: setDocumentType, instructions: instructions, setInstructions: setInstructions, documentCount: classification === null || classification === void 0 ? void 0 : classification.total, onBack: () => setStep(2), onGenerate: onGenerate }), genError && _jsx("div", { className: "error-banner", children: genError })] }))] })) })] }));
}
